import { render, staticRenderFns } from "./plan-top.vue?vue&type=template&id=118beacb&scoped=true"
import script from "./plan-top.vue?vue&type=script&lang=js"
export * from "./plan-top.vue?vue&type=script&lang=js"
import style0 from "./plan-top.vue?vue&type=style&index=0&id=118beacb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "118beacb",
  null
  
)

export default component.exports